'use client';

import { Link } from '@hc-frontend/core-ui';
import { usePathname, useSearchParams } from 'next/navigation';

import type { FilterItemProps } from './filter-item.types';

export function FilterItem({
  type,
  filter,
  onClick,
  itemRenderer,
}: FilterItemProps) {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const { name, value, label } = filter;
  const filterId = `${name}-${value}`;
  const params = new URLSearchParams(searchParams.toString());
  const param = params.getAll(name);
  const active = param.includes(value);

  const buildFilterLink = () => {
    const activeMethods = {
      checkbox: () => params.delete(name, value),
      radio: () => params.delete(name),
    };

    const inactiveMethods = {
      checkbox: () => params.append(name, value),
      radio: () => params.set(name, value),
    };

    if (active) {
      activeMethods[type]?.();
    } else {
      inactiveMethods[type]?.();
    }

    return `${pathname}?${params.toString()}`;
  };

  const link = buildFilterLink();

  const handleClick = () => {
    onClick?.(filter);
  };

  return (
    <Link
      id={`${filterId}-link`}
      href={link}
      prefetch={false}
      className="flex w-full items-center gap-12-12 rounded-md border border-gray-50 px-16-16 py-8-12"
      replace
      onClick={handleClick}
    >
      <input
        name={name}
        className="pointer-events-none cursor-pointer accent-primary-950"
        id={filterId}
        value={value}
        type={type}
        checked={active}
        readOnly
      />
      <label
        className="hc-label pointer-events-none cursor-pointer text-text-950"
        htmlFor={filterId}
      >
        {itemRenderer ? itemRenderer(value) : label ?? value}
      </label>
    </Link>
  );
}
